// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-chart-view {
  margin: 0 auto 12px;
  max-width: 960px;
}
.analytics-chart-view .analytics-chart-tooltip {
  background-color: var(--primary-color-light-500) !important;
  color: var(--primary-color-500) !important;
}
.analytics-chart-view .analytics-chart-tooltip div {
  display: block;
}
.analytics-chart-view .analytics-chart-tooltip div div {
  color: var(--primary-color-500) !important;
}
.analytics-chart-view .analytics-chart-tooltip div div div {
  color: var(--primary-color-500) !important;
}
.analytics-chart-view .analytics-chart-tooltip div div div span {
  color: var(--primary-color-500) !important;
}
.analytics-chart-view .analytics-chart-tooltip .chart-projected-value {
  font-weight: 600;
  color: var(--secondary-color-500);
}
.analytics-chart-view .analytics-chart-tooltip .chart-original-value {
  font-weight: 600;
}
.analytics-chart-view__footer {
  margin-top: 0;
  margin-bottom: 8px;
  padding: 6px 10px 4px;
}
.analytics-chart-view__footer :global(.analytics-chart-divergence-note) {
  background: #fffbeb;
  background: var(--warning-bg, #fffbeb);
  border-color: #fcd34d;
  border-color: var(--warning-border, #fcd34d);
  color: #78350f;
  color: var(--warning-text, #78350f);
}
.analytics-chart-view__footer :global(.info-message) {
  font-size: 0.75rem !important;
  padding: 6px 10px !important;
}
.analytics-chart-view__footer :global(.info-message) .info-message__icon {
  font-size: 1rem !important;
}
.analytics-chart-view__footer :global(.info-message) .info-message__text {
  line-height: 1.2 !important;
}
.analytics-chart-view .analytics-chart-custom-legend {
  text-align: center;
  line-height: 1.9;
  padding: 6px 12px 2px;
}
.analytics-chart-view .analytics-chart-legend-item {
  display: inline-block;
  vertical-align: middle;
  margin: 3px 7px;
  cursor: pointer;
  font-size: 0.72rem;
  color: #374151;
  color: var(--text-primary, #374151);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}
.analytics-chart-view .analytics-chart-legend-item.is-hidden .analytics-chart-legend-name {
  text-decoration: line-through;
  color: #9ca3af;
  color: var(--text-muted, #9ca3af);
}
.analytics-chart-view .analytics-chart-legend-item.is-hidden .analytics-chart-legend-icon {
  opacity: 0.3;
}
.analytics-chart-view .analytics-chart-legend-checkbox {
  display: inline-block;
  vertical-align: middle;
  width: 11px;
  height: 11px;
  margin-right: 5px;
  border: 1.5px solid #9ca3af;
  border-radius: 2px;
  position: relative;
  background: #fff;
}
.analytics-chart-view .analytics-chart-legend-checkbox.is-checked {
  background: #6366f1;
  background: var(--primary-color-500, #6366f1);
  border-color: #6366f1;
  border-color: var(--primary-color-500, #6366f1);
}
.analytics-chart-view .analytics-chart-legend-checkbox.is-checked::after {
  content: "";
  position: absolute;
  left: 2px;
  top: -1px;
  width: 3px;
  height: 6px;
  border: 1.5px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg);
}
.analytics-chart-view .analytics-chart-legend-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 0;
  margin-right: 5px;
  border-bottom: 2px solid;
}
.analytics-chart-view .analytics-chart-legend-icon.is-dashed {
  border-bottom-style: dashed;
}
.analytics-chart-view .analytics-chart-actions {
  display: flex;
  justify-content: flex-start !important;
  align-items: center;
  padding: 2px 10px 4px;
  overflow: visible !important;
  width: 100%;
}
.analytics-chart-view .delete-chart-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 4px !important;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 11px;
  z-index: 8;
}
.analytics-chart-view .delete-chart-btn:hover {
  background: rgba(0, 0, 0, 0.7);
}

:global(.analytics-chart-tooltip) {
  background-color: var(--primary-color-light-500) !important;
  color: var(--primary-color-500) !important;
}
:global(.analytics-chart-tooltip) .chart-original-value {
  font-weight: 400;
  color: inherit;
}
:global(.analytics-chart-tooltip) .chart-projected-value {
  font-weight: 600;
  font-style: italic;
  color: var(--secondary-color-500);
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/AnalyticsChart/AnalyticsChart.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;AACF;AAAE;EACE,2DAAA;EACA,0CAAA;AAEJ;AAAI;EACE,cAAA;AAEN;AAAM;EACE,0CAAA;AAER;AAAQ;EACE,0CAAA;AAEV;AAAU;EACE,0CAAA;AAEZ;AAII;EACE,gBAAA;EACA,iCAAA;AAFN;AAMI;EACE,gBAAA;AAJN;AAQE;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;AANJ;AAQI;EACE,mBAAA;EAAA,sCAAA;EACA,qBAAA;EAAA,4CAAA;EACA,cAAA;EAAA,mCAAA;AANN;AAUI;EACE,6BAAA;EACA,4BAAA;AARN;AAUM;EACE,0BAAA;AARR;AAWM;EACE,2BAAA;AATR;AAiBE;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;AAfJ;AAkBE;EACE,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EAAA,mCAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,6BAAA;EACA,cAAA;EAAA,iCAAA;AAhBN;AAmBI;EACE,YAAA;AAjBN;AAqBE;EACE,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAnBJ;AAqBI;EACE,mBAAA;EAAA,6CAAA;EACA,qBAAA;EAAA,+CAAA;AAnBN;AAqBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAnBR;AAwBE;EACE,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,wBAAA;AAtBJ;AAwBI;EACE,2BAAA;AAtBN;AA0BE;EACE,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,qBAAA;EACA,4BAAA;EACA,WAAA;AAxBJ;AA2BE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AAzBJ;AA2BI;EACE,8BAAA;AAzBN;;AA+BA;EACE,2DAAA;EACA,0CAAA;AA5BF;AA+BE;EACE,gBAAA;EACA,cAAA;AA7BJ;AAiCE;EACE,gBAAA;EACA,kBAAA;EACA,iCAAA;AA/BJ","sourcesContent":[".analytics-chart-view {\n  margin: 0 auto 12px;\n  max-width: 960px;\n  .analytics-chart-tooltip {\n    background-color: var(--primary-color-light-500) !important;\n    color: var(--primary-color-500) !important;\n\n    div {\n      display: block;\n\n      div {\n        color: var(--primary-color-500) !important;\n\n        div {\n          color: var(--primary-color-500) !important;\n\n          span {\n            color: var(--primary-color-500) !important;\n          }\n        }\n      }\n    }\n\n    .chart-projected-value {\n      font-weight: 600;\n      color: var(--secondary-color-500);\n\n    }\n\n    .chart-original-value {\n      font-weight: 600;\n    }\n  }\n\n  &__footer {\n    margin-top: 0;\n    margin-bottom: 8px;\n    padding: 6px 10px 4px;\n\n    :global(.analytics-chart-divergence-note) {\n      background: var(--warning-bg, #fffbeb);\n      border-color: var(--warning-border, #fcd34d);\n      color: var(--warning-text, #78350f);\n    }\n\n    // Target the InfoMessage component inside footer specific to AnalyticsChart\n    :global(.info-message) {\n      font-size: 0.75rem !important; // Smaller font\n      padding: 6px 10px !important; // Less padding\n\n      .info-message__icon {\n        font-size: 1rem !important; // Smaller icon\n      }\n\n      .info-message__text {\n        line-height: 1.2 !important;\n      }\n    }\n  }\n\n  // Note: html2canvas has incomplete/buggy flexbox support, so this legend\n  // deliberately avoids display:flex/inline-flex — plain inline-block +\n  // vertical-align + margin is what renders correctly in downloaded screenshots.\n  .analytics-chart-custom-legend {\n    text-align: center;\n    line-height: 1.9;\n    padding: 6px 12px 2px;\n  }\n\n  .analytics-chart-legend-item {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 3px 7px;\n    cursor: pointer;\n    font-size: 0.72rem;\n    color: var(--text-primary, #374151);\n    user-select: none;\n    white-space: nowrap;\n\n    &.is-hidden .analytics-chart-legend-name {\n      text-decoration: line-through;\n      color: var(--text-muted, #9ca3af);\n    }\n\n    &.is-hidden .analytics-chart-legend-icon {\n      opacity: 0.3;\n    }\n  }\n\n  .analytics-chart-legend-checkbox {\n    display: inline-block;\n    vertical-align: middle;\n    width: 11px;\n    height: 11px;\n    margin-right: 5px;\n    border: 1.5px solid #9ca3af;\n    border-radius: 2px;\n    position: relative;\n    background: #fff;\n\n    &.is-checked {\n      background: var(--primary-color-500, #6366f1);\n      border-color: var(--primary-color-500, #6366f1);\n\n      &::after {\n        content: '';\n        position: absolute;\n        left: 2px;\n        top: -1px;\n        width: 3px;\n        height: 6px;\n        border: 1.5px solid #fff;\n        border-top: none;\n        border-left: none;\n        transform: rotate(45deg);\n      }\n    }\n  }\n\n  .analytics-chart-legend-icon {\n    display: inline-block;\n    vertical-align: middle;\n    width: 16px;\n    height: 0;\n    margin-right: 5px;\n    border-bottom: 2px solid;\n\n    &.is-dashed {\n      border-bottom-style: dashed;\n    }\n  }\n\n  .analytics-chart-actions {\n    display: flex;\n    justify-content: flex-start !important;\n    align-items: center;\n    padding: 2px 10px 4px;\n    overflow: visible !important;\n    width: 100%;\n  }\n\n  .delete-chart-btn {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background: rgba(0, 0, 0, 0.5);\n    color: white;\n    border: none;\n    border-radius: 4px !important;\n    padding: 4px 8px;\n    cursor: pointer;\n    font-size: 11px;\n    z-index: 8; // Below sticky header (z-index: 9)\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.7);\n    }\n  }\n}\n\n// Global styles for chart tooltips\n:global(.analytics-chart-tooltip) {\n  background-color: var(--primary-color-light-500) !important;\n  color: var(--primary-color-500) !important;\n\n  // Style for original (non-projected) values in tooltips\n  .chart-original-value {\n    font-weight: 400;\n    color: inherit;\n  }\n\n  // Style for projected values in tooltips\n  .chart-projected-value {\n    font-weight: 600;\n    font-style: italic;\n    color: var(--secondary-color-500);\n\n    // Uncomment to add more custom styles:\n    // text-decoration: underline;\n    // background-color: rgba(255, 152, 0, 0.1);\n    // padding: 2px 4px;\n    // border-radius: 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
